module.exports = __webpack_public_path__ + "9065d6b6cd3b1de169f279684d426d87.woff";